module.exports = __webpack_public_path__ + "img/logo@2x.7cff5b4d.png";